import { V3Models } from "@istari/istari-client";

import { checkIsLinkedModel, normalizeFileExtension, stripExtensionFromDisplayName } from "~/utils/file";

export function toResourceDirectoryLabel(
  dto: Pick<V3Models.ResourceDto, "displayName" | "name" | "extension">,
): string {
  return appendExtension(firstNonEmptyName(dto.displayName, dto.name), dto.extension) || "Unknown";
}

function firstNonEmptyName(displayName?: string | null, name?: string | null): string | undefined {
  const trimmedDisplayName = displayName?.trim();
  if (trimmedDisplayName) {
    return trimmedDisplayName;
  }
  const trimmedName = name?.trim();
  return trimmedName || undefined;
}

function appendExtension(displayName: string | null | undefined, extension: string | null | undefined) {
  if (!displayName) {
    return undefined;
  }
  if (!extension) {
    return displayName;
  }
  if (checkIsLinkedModel(normalizeFileExtension(extension))) {
    return stripExtensionFromDisplayName(displayName, extension) ?? displayName;
  }
  const withoutDot = extension.startsWith(".") ? extension.slice(1) : extension;
  if (!withoutDot || displayName.toLowerCase().endsWith(`.${withoutDot.toLowerCase()}`)) {
    return displayName;
  }
  return `${displayName}.${withoutDot}`;
}
